import { NLRequest, NLError, NLResponse } from './ask.types';
import { getBaseUrl } from './utils';

export const ask = async (payload: NLRequest): Promise<NLResponse | NLError> => {
    const path = `/alt-search/mobile-bff/relevance/ask`;
    const url = `${getBaseUrl()}${path}`;

    const responsePromise = fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });

    const response = await responsePromise.catch((error) => {
        return {
            status: '400',
            statusText: 'Unexpected error ' + error,
            error: error,
            text: async () => 'Unexpected error.',
            ok: false,
        } as any;
    });

    if (!response.ok) {
        return {
            message: `Unable to retrieve results. Status: ${response.statusText}`,
            status: `${response.status}: ${response.statusText}`,
            error: await response.text(),
        };
    }

    const responseBody: NLResponse = await response.json();

    return responseBody;
};
